AgrimarketControllers.controller('userContractsBaseMonitoringController', [
    function () {

    }]);
 